/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileResponseModel } from '../../models/profile-response-model';

export interface SessionSessionProfileSystemIdentifierIdProfileIdGet$Params {

/**
 * The system identifier ID
 */
  systemIdentifierId: string;

/**
 * The profile ID
 */
  profileId: string;
}

export function sessionSessionProfileSystemIdentifierIdProfileIdGet(http: HttpClient, rootUrl: string, params: SessionSessionProfileSystemIdentifierIdProfileIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<ProfileResponseModel>> {
  const rb = new RequestBuilder(rootUrl, sessionSessionProfileSystemIdentifierIdProfileIdGet.PATH, 'get');
  if (params) {
    rb.path('systemIdentifierId', params.systemIdentifierId, {});
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<ProfileResponseModel>;
    })
  );
}

sessionSessionProfileSystemIdentifierIdProfileIdGet.PATH = '/Session/SessionProfile/{systemIdentifierId}/{profileId}';
